<template>
	<div class="row">

		<div class="col-6 form-group">
			<label for="centre">{{ $t("monte.congelation.centre_provenance") }}</label>
			<SearchTiers
				v-if="search_all_tiers"
				id="centre"
				:tiers_selected.sync="tiers"
			/>
			<e-select
				v-else
				v-model="centre_selected"
				id="centre"
				track-by="tiers_id"
				label="tiers_rs"
				:placeholder="$t('monte.congelation.selectionner_centre')"
				:selectedLabel="$t('global.selected_label')"
				:options="centres"
				:searchable="true"
				:show-labels="false"
				:allow-empty="true"
			>
				<template slot="option" slot-scope="{ option }"><tiers-moral-icon :moral="option.tiers_moral" />{{ option.tiers_rs }}</template>
				<template slot="singleLabel" slot-scope="{ option }"><tiers-moral-icon :moral="option.tiers_moral" />{{ option.tiers_rs }}</template>
				<template slot="noOptions">{{ $t('global.list_empty') }}</template>
			</e-select>
		</div>

		<div v-if="selected_centre" class="col-6 form-group">
			<label>{{ $t("monte.congelation.paillettes_envoyees") }}</label>
			<div class="form-control-plaintext"><b>{{ selected_centre.total_envoye }}</b> {{ $t('monte.paillettes') }}</div>
			<ul class="mb-0 pl-4">
				<li v-for="(envoi, index) in selected_centre.envois" :key="index">
					{{ envoi.qte }} {{ $t('monte.paillettes') }} - {{ formatDate(envoi.date) }}
				</li>
			</ul>
		</div>
		
		<div class="col-12 form-group">
			<label for="search_all_tiers">{{ $t("monte.congelation.chercher_tous_tiers") }}</label>
			<b-form-checkbox v-model="search_all_tiers" id="search_all_tiers" />
		</div>

		<div class="col-6 form-group">
			<label>{{ $t("monte.congelation.deja_revenues") }}</label>
			<div class="form-control"><b>{{ total_retour }}</b> {{ $t('monte.paillettes') }}</div>
		</div>

		<div class="col-6 form-group">
			<label for="qte">{{ $t("monte.congelation.qte_retour") }} *</label>
			<input class="form-control" type="number" v-model="qte" id="qte">
		</div>
		<div class="col-6 form-group">
			<label for="date">{{ $t("monte.congelation.date_retour") }} *</label>
			<e-datepicker id="date" v-model="date" mode="date"></e-datepicker>
		</div>

		<div class="col-6 form-group">
			<div>
				<label for="stockage">{{ $t("monte.stock_semence.localisation") }} *</label>
				<a class="ml-1" href="" @click.prevent="setUpEmplacementLot(lot)">
					<font-awesome-icon :icon="['fas', 'eye']" />
				</a>
			</div>
			<e-select
				v-model="localisation_selected"
				id="stockage"
				track-by="full_name"
				label="full_name"
				:placeholder="$t('monte.stock_semence.rechercher_categorie')"
				:selectedLabel="$t('global.selected_label')"
				:options="all_localisations"
				:searchable="true"
				:show-labels="false"
				:allow-empty="true"
				:sortable="false"
			>
				<template slot="option" slot-scope="props"><span :style="`padding-left: ${25 * (props.option.indent || 0) }px;`">{{ props.option.full_name }}</span></template>
			</e-select>
		</div>
		<div class="col-6 form-group">
			<label for="commentaire">{{ $t("monte.congelation.commentaire") }}</label>
			<input class="form-control" type="text" v-model="commentaire" id="commentaire">
		</div>

		<div class="col-3 form-group">
			<label for="norme_lock">{{ $t("monte.congelation.norme_lock") }}</label>
			<b-form-checkbox v-model="norme_lock" id="norme_lock" />
		</div>
		<div class="col-3 form-group">
			<label for="control_apte">{{ $t("monte.congelation.definir_apte") }}</label>
			<b-form-checkbox v-model="control_apte" id="control_apte" />
		</div>

		<div class="col-12 text-center">
			<a class="btn btn-primary mt-3" href="#" @click.prevent="checkForm">{{ $t('global.ajouter') }} <font-awesome-icon v-if="processing" :icon="['fal', 'spinner']" pulse /><font-awesome-icon v-else :icon="['fal', 'save']" /></a>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"
	import StockSemence from "@/mixins/StockSemence.js"
	import Shutter from '@/mixins/Shutter.js'
	import ShutterCongelation from "@/mixins/shutters-manager/Congelation.js"

	export default {
		name: 'RetourPaillettes',
		mixins: [Congelation, StockSemence, Shutter, ShutterCongelation],
		props: ['lot'],
		data () {
			return {
				centres: [],
				centre_selected: null,
				search_all_tiers: false,
				tiers: null,
				total_retour: 0,
				qte: 1,
				date: new Date(),
				localisation_selected: null,
				all_localisations: [],
				commentaire: '',
				norme_lock: true,
				control_apte: true,
				processing: false
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				const infos = await this.getRetourInfosByLot(this.lot.semencelot_id)
				this.centres = infos.centres
				this.total_retour = infos.total_retour

				const all_localisations = await this.getLocalisationSemenceFullName()
				this.all_localisations = all_localisations.filter(loc => !loc.semencelocalisation_transport && loc.semencelocalisation_is_floor && !loc.semencelocalisation_command)
			},

			async checkForm() {
				if(!this.date || !this.qte || !this.localisation_selected) {
					this.failureToast("toast.all_inputs")
					return false
				}

				this.processing = true
				await this.addRetour(this.lot.semencelot_id, this.qte, this.commentaire, this.localisation_selected.semencelocalisation_id, this.date, this.norme_lock, this.tiers_id, this.control_apte)
				this.processing = false
				this.ok()
				this.shutterPanel().keepFirst()
			}
		},

		computed: {
			// Le centre de provenance vient soit du sélecteur prérempli, soit de la recherche libre
			tiers_id() {
				const selected = this.search_all_tiers ? this.tiers : this.centre_selected
				return selected ? selected.tiers_id : null
			},

			// Les envois ne sont connus que pour les centres ayant déjà reçu des paillettes de ce lot,
			// y compris lorsque le tiers vient de la recherche libre
			selected_centre() {
				return this.centres.find(centre => centre.tiers_id == this.tiers_id) || null
			}
		},

		components: {
			SearchTiers : () => import('@/components/Contract/SearchTiers')
		}
	}

</script>
